export default function Laptop() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_5137)">
                <path
                    d="M38.25 9H9.75C8.50736 9 7.5 10.0074 7.5 11.25V31.5H40.5V11.25C40.5 10.0074 39.4926 9 38.25 9Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M40.1767 39H7.82332C6.23153 39 5.14307 37.3923 5.73425 35.9144L7.5 31.5H40.5L42.2657 35.9144C42.8569 37.3923 41.7685 39 40.1767 39Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M22.5 12H25.5" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_845_5137">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
